/**
 * Marketing analytics — reuses the app's EXISTING PostHog instance
 * (initialized globally as window.posthog in public/index.html).
 * No new provider, snippet, dependency, or env var is introduced.
 * Only non-PII values (route strings, CTA location ids) are ever passed.
 */
export const track = (event, props = {}) => {
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, props);
    }
  } catch (e) {
    // Analytics must never break the UI.
  }
};
